import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Hide } from 'pcln-design-system'
import { ChangeSearchOptions } from '../ChangeSearchOptions/ChangeSearchOptions'
import { ChangeSearchSlices } from '../ChangeSearchSlices/ChangeSearchSlices'
import { ChangeSearchPassengers } from '../ChangeSearchPassengers.js/ChangeSearchPassengers'
import { ChangeSearchSubmitButton } from '../ChangeSearchSubmitButton/ChangeSearchSubmitButton'
import { ChangeSearchFlexDates } from '../ChangeSearchOptions/ChangeSearchFlexDates/ChangeSearchFlexDates'
import { Wrapper } from './ChangeSearchWrapper.styles'

const ChangeSearchWrapper = ({
  airports,
  setAirports,
  isWhiteLabel,
  pclnExpt,
  tripType,
  setTripType,
  cabinClass,
  setCabinClass,
  passengers,
  setPassengers,
  useFlexDates,
  setUseFlexDates,
  tripSlices,
  setTripSlices,
  submitSearch,
  updateSlicesForTripType,
  addSlice,
  swapSlices,
  removeSlice,
  validationError,
  updateSlice,
  displayFlexibleDatesCheckbox,
  isReshopExperience,
  subLabelMap,
  lapInfantLabel,
}) => (
  <Wrapper p={2} data-testid='csh-wrapper'>
    <Box px={[0, 0, 0, 0, 2]} width={1} maxWidth='1370px'>
      <ChangeSearchOptions
        tripType={tripType}
        setTripType={setTripType}
        cabinClass={cabinClass}
        setCabinClass={setCabinClass}
        updateSlicesForTripType={updateSlicesForTripType}
        setUseFlexDates={setUseFlexDates}
        useFlexDates={useFlexDates}
        displayFlexibleDatesCheckbox={displayFlexibleDatesCheckbox}
        isReshopExperience={isReshopExperience}
      />
      <Flex alignItems='start' flexDirection={['column', null, null, null, 'row']}>
        <Box width={1}>
          <ChangeSearchSlices
            tripType={tripType}
            tripSlices={tripSlices}
            setTripSlices={setTripSlices}
            airports={airports}
            setAirports={setAirports}
            removeSlice={removeSlice}
            addSlice={addSlice}
            swapSlices={swapSlices}
            cabinClass={cabinClass}
            updateSlice={updateSlice}
            pclnExpt={pclnExpt}
            validationError={validationError}
          />
        </Box>
        <Box width={[1, null, null, null, '25%']} mx={[0, null, null, null, 2]} mb={[3, null, null, null, 0]}>
          <ChangeSearchPassengers
            setPassengers={setPassengers}
            passengers={passengers}
            isWhiteLabel={isWhiteLabel}
            isReshopExperience={isReshopExperience}
            subLabelMap={subLabelMap}
            lapInfantLabel={lapInfantLabel}
          />
        </Box>
        {displayFlexibleDatesCheckbox ? (
          <Hide xl xxl width={1}>
            <Box mb={3} data-testid='mobile-flex-dates'>
              <ChangeSearchFlexDates
                useFlexDates={useFlexDates}
                setUseFlexDates={setUseFlexDates}
                tripType={tripType}
                isMobile
              />
            </Box>
          </Hide>
        ) : null}
        <Box width={[1, null, null, null, '100px']}>
          <ChangeSearchSubmitButton submitSearch={submitSearch} />
        </Box>
      </Flex>
    </Box>
  </Wrapper>
)

ChangeSearchWrapper.propTypes = {
  airports: PropTypes.object,
  setAirports: PropTypes.func,
  isWhiteLabel: PropTypes.bool,
  pclnExpt: PropTypes.any,
  tripType: PropTypes.string,
  setTripType: PropTypes.func,
  cabinClass: PropTypes.string,
  setCabinClass: PropTypes.func,
  passengers: PropTypes.object,
  setPassengers: PropTypes.func,
  useFlexDates: PropTypes.bool,
  setUseFlexDates: PropTypes.func,
  tripSlices: PropTypes.array,
  validationError: PropTypes.bool,
  setTripSlices: PropTypes.func,
  submitSearch: PropTypes.func,
  updateSlicesForTripType: PropTypes.func,
  addSlice: PropTypes.func,
  swapSlices: PropTypes.func,
  removeSlice: PropTypes.func,
  updateSlice: PropTypes.func,
  displayFlexibleDatesCheckbox: PropTypes.bool,
  isReshopExperience: PropTypes.bool,
  subLabelMap: PropTypes.objectOf({
    adults: PropTypes.string,
    youths: PropTypes.string,
    children: PropTypes.string,
    lapInfants: PropTypes.string,
  }),
  lapInfantLabel: PropTypes.string,
}

export { ChangeSearchWrapper }
